// Device-local UI preferences for the admin console (no backend). Persisted to
// localStorage. Mirrors the shape used by the public site's own preferences
// module, minus the settings that only exist there.

const KEY = 'pm-admin-prefs';

export const DEFAULT_PREFS = {
  navPinned: false,   // keep the sidebar flyout open instead of resting as a rail
};

export function getPrefs() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '{}');
    return { ...DEFAULT_PREFS, ...(raw && typeof raw === 'object' ? raw : {}) };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function setPrefs(patch) {
  const next = { ...getPrefs(), ...patch };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* noop */ }
  return next;
}
